import { useQuery } from 'react-query';
import { PagosType, UserType } from '../types/types';

const baseRoute = process.env.REACT_APP_BASE_URL;

async function pagosApiCall(user?: UserType | null) {
  if (!user?.token) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/all-pagos`,
    { headers, method: 'GET' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as PagosType[];
}


export function useGetPagos(user?: UserType | null) {
  return useQuery<PagosType[] | null, Error>(
    ['getPagos', user?._id],
    () => pagosApiCall(user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}
